import { css, StyleDeclarationValue } from 'aphrodite';
import { styleSheet } from './styles';

interface IProps {
	companyDisplayName?: string;
	name?: string;
	styles?: StyleDeclarationValue[];
}

export function SurveyHeader({ name, companyDisplayName, styles = [] }: IProps) {
	if (!name) {
		return null;
	}
	return (
		<section className={css(styleSheet.header, ...styles)}>
			<h2 className={css(styleSheet.heading)}>{name}</h2>
			{companyDisplayName ? <p>{companyDisplayName}</p> : null}
		</section>
	);
}
